import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { _ as _objectSpread2 } from '../../dist/objectSpread2-811c5212.esm.js';
import { useDebugHydration, useForceHydration } from '../../context/selectors/dist/uswitch-ev-utils-context-selectors.esm.js';
import { jsx } from 'theme-ui/jsx-runtime';
import '@babel/runtime/helpers/slicedToArray';
import 'react';
import '../../obj/dist/uswitch-ev-utils-obj.esm.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/typeof';
import '../../nil/dist/uswitch-ev-utils-nil.esm.js';
import '../../contentful/dist/uswitch-ev-utils-contentful.esm.js';
import '../../context/provider/dist/uswitch-ev-utils-context-provider.esm.js';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import '../../conditional-wrapper/dist/uswitch-ev-utils-conditional-wrapper.esm.js';
import 'react-chansey';
import 'react-chansey/lib/provider';
import '../../helpers/env/dist/uswitch-ev-utils-helpers-env.esm.js';

var _excluded = ["As", "force", "children"];
var green = {
  background: '#eeffee',
  '&>*': {
    background: '#eeffee !important'
  }
};
var red = {
  background: '#ffeeee',
  '&>*': {
    background: '#ffeeee !important'
  }
};
var RedWrapper = function RedWrapper(props) {
  var debugHydration = useDebugHydration();
  return jsx("span", _objectSpread2(_objectSpread2({}, props), {}, {
    sx: debugHydration ? red : {}
  }));
};
var GreenWrapper = function GreenWrapper(props) {
  var debugHydration = useDebugHydration();
  return jsx("span", _objectSpread2(_objectSpread2({}, props), {}, {
    sx: debugHydration ? green : {}
  }));
};
var ConditionalHydrate = function ConditionalHydrate(_ref) {
  var _ref$As = _ref.As,
    As = _ref$As === void 0 ? 'span' : _ref$As,
    _ref$force = _ref.force,
    force = _ref$force === void 0 ? false : _ref$force,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var isServer = typeof window === 'undefined';
  var debugHydration = useDebugHydration();
  var forceHydrationHookVal = useForceHydration();
  var forceHydration = force || forceHydrationHookVal;
  return isServer ? jsx(As, _objectSpread2(_objectSpread2({
    sx: debugHydration ? green : {},
    className: props.className
  }, props), {}, {
    children: children
  })) : forceHydration ? jsx(As, _objectSpread2(_objectSpread2({
    sx: debugHydration ? red : {},
    className: props.className
  }, props), {}, {
    children: children
  })) : jsx(As, _objectSpread2({
    className: props.className,
    dangerouslySetInnerHTML: {
      __html: ''
    },
    suppressHydrationWarning: true
  }, props));
};

export { GreenWrapper, RedWrapper, ConditionalHydrate as default };
